<div mat-dialog-content class="info">{{data.info}}</div>
<div mat-dialog-actions class="btn-section">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
    <button mat-button [mat-dialog-close]="false">No</button>
</div>
